import { haveFilterQuery, paginator, haveSort } from '../common/auxFun'

const endpointsCompanies = {
  LOAD: (filter, sort, limit, skip) =>
    `/v1/settings/companies${haveFilterQuery(filter)}${paginator(limit, skip)}${haveSort(sort)}`,
  BY_ID: (id) => `/v1/settings/companies/${id}`,
  CREATE: `/v1/settings/companies/`,
  UPDATE: (id) => `/v1/settings/companies/${id}`,
  REMOVE: (id) => `/v1/settings/companies/${id}`,
}

export default endpointsCompanies
